import { Helmet } from 'react-helmet';
import React, { forwardRef, useEffect, useCallback } from 'react';

const Page = forwardRef<any, any>(
  ({ children, title = '', ...other }: Props, ref) => {
    const sendPageViewEvent = useCallback(() => {
      // track.pageview({
      //   page_path: pathname
      // });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      sendPageViewEvent();
    }, [sendPageViewEvent]);

    return (
      <div ref={ref} {...other}>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        {children}
      </div>
    );
  }
);

type Props = {
  children: React.ReactNode;
  title?: string;
};

export default Page;
